// export const cepexApiBaseUrl = process.env.ENV === 'production' ? 'https://api.cepex.aryuuu.com' : 'http://localhost:3001'
export const cepexApiBaseUrl = 'https://api.cepex.aryuuu.com';
